import sitemapSchema from './sitemap/schema.json';

export default {
  sitemap: {
    schema: sitemapSchema,
  },
};
